import CopyFixList from './CopyFixList';
import { extractAnswerCapsules } from '../../../../lib/optimizedContent';

export default function CapsulesFix({ domain, onFixApplied }) {
  return (
    <CopyFixList
      domain={domain}
      pillarCode="answerCapsules"
      threshold={9}
      extract={extractAnswerCapsules}
      copyLabel={(e) => `${e.count} Answer Capsule${e.count === 1 ? '' : 's'}`}
      clipboardText={(e) => e.html}
      emptyHint="Re-audit if you’ve recently added Answer Capsules."
      onFixApplied={onFixApplied}
      instructions={[
        <>
          Paste the copied <code className="px-1 bg-white border border-emerald-200 rounded text-[10px]">&lt;blockquote class=&quot;answer-capsule&quot;&gt;</code> blocks into your page body where you want to highlight key facts (often near the top, after the intro).
        </>,
        'Deploy the change to your live site.',
        <>
          Re-run the audit — <strong>Answer Capsules used</strong> should now Pass.
        </>,
      ]}
    />
  );
}
